import Vue from "vue"
import index from "./"
import store from "./store/index"
import "./assets/css/index.scss"
import Toast from "@/plugin/Toast"
// import sensorLog from "@/utils/sensorLog"
import isBrowserSupport from "@/utils/browserSupport"
import { notSupport } from "@/utils/notSupport.js"
import EventEmitter from "events"
import { AudioController } from "@/utils/mixing"
import VueI18n from "vue-i18n"
import messages from "@/assets/i18n"

// 神策初始化,放到sdk里面去初始化了
// sensorLog.initSensor()

// 判断浏览器支持度
let res = notSupport(
  isBrowserSupport({
    os: "Windows",
    osver: ["XP", "Vista"]
  })
)

// 浏览器支持后才走
if (res) {
  Vue.use(VueI18n)
  Vue.use(Toast)
  const i18n = new VueI18n({
    locale: navigator.language.slice(0, 2),
    messages
  })
  Vue.prototype.$eventSource = new EventEmitter()
  Vue.prototype.$audioMixing = new AudioController()
  new Vue({
    i18n,
    store,
    render: h => h(index)
  }).$mount("#app")
}
